var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIconTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73684 6.78788C8.59789 6.78788 10.1053 5.26909 10.1053 3.39394C10.1053 1.51879 8.59789 0 6.73684 0C4.87579 0 3.36842 1.51879 3.36842 3.39394C3.36842 5.26909 4.87579 6.78788 6.73684 6.78788ZM6.73684 1.69697C7.66316 1.69697 8.42105 2.46061 8.42105 3.39394C8.42105 4.32727 7.66316 5.09091 6.73684 5.09091C5.81053 5.09091 5.05263 4.32727 5.05263 3.39394C5.05263 2.46061 5.81053 1.69697 6.73684 1.69697ZM1.68421 11.8788C1.85263 11.3442 3.84842 10.4533 5.86105 10.2327L7.57895 8.53576C7.25053 8.50182 7.00632 8.48485 6.73684 8.48485C4.48842 8.48485 0 9.62182 0 11.8788V13.5758H7.57895L5.89474 11.8788H1.68421ZM14.8211 7.21212L10.5011 11.5988L8.75789 9.83394L7.57895 11.0303L10.5011 14L16 8.40849L14.8211 7.21212Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIconTick);
export default __webpack_public_path__ + "static/media/personIconTick.6bca79b37af00981fa67db5b2b3f3920.svg";
export { ForwardRef as ReactComponent };